"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var store_1 = require("@ngrx/store");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_reporting_controls_1 = require("@synisys/idm-reporting-controls");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var from_1 = require("rxjs/observable/from");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var report_view_styles_1 = require("../common/model/style/report-view-styles");
var report_view_styles_deserializer_1 = require("../common/model/style/report-view-styles-deserializer");
var report_deserializer_1 = require("../common/report-deserializer");
var tree_utils_1 = require("../common/tree-utils");
var sis_tabular_report_view_big_data_warning_popup_component_1 = require("../report-view-warning-popup/sis-tabular-report-view-big-data-warning-popup.component");
var sis_tabular_report_designer_component_1 = require("../sis-tabular-report-designer/sis-tabular-report-designer.component");
var cell_value_formatter_1 = require("../sis-tabular-report-options/formatter/cell-value-formatter");
var sis_tabular_report_options_component_1 = require("../sis-tabular-report-options/sis-tabular-report-options.component");
var export_report_dto_converter_1 = require("./converter/export-report-dto-converter");
var report_json_converter_1 = require("./converter/report-json-converter");
var row_formatting_rules_column_tree_setter_1 = require("./converter/row-formatting-rules-column-tree-setter");
var Subject_1 = require("rxjs/Subject");
var idm_report_export_service_client_js_2 = require("@synisys/idm-report-export-service-client-js");
/**
 * Created by Hayk.Andriasyan on 7/10/2017.
 */
var SisTabularReportViewComponent = /** @class */ (function () {
    function SisTabularReportViewComponent(_elementRef, dialog, _currentLanguageProvider, _reportingService, _pathService, _expressionPathService, _categoryPathService, _http, _messageService, _formResolverService, _pathFormsService, _reportExportService, _eventBase, _cd, localeService, store, staticResourceUrlProvider, kbService, _activatedRoute, communicationService, pageFilterService) {
        this._elementRef = _elementRef;
        this.dialog = dialog;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._reportingService = _reportingService;
        this._pathService = _pathService;
        this._expressionPathService = _expressionPathService;
        this._categoryPathService = _categoryPathService;
        this._http = _http;
        this._messageService = _messageService;
        this._formResolverService = _formResolverService;
        this._pathFormsService = _pathFormsService;
        this._reportExportService = _reportExportService;
        this._eventBase = _eventBase;
        this._cd = _cd;
        this.localeService = localeService;
        this.store = store;
        this.staticResourceUrlProvider = staticResourceUrlProvider;
        this.kbService = kbService;
        this._activatedRoute = _activatedRoute;
        this.communicationService = communicationService;
        this.pageFilterService = pageFilterService;
        this.MeasurePathType = idm_dataset_service_client_js_1.MeasurePathType;
        this.ReportElementViewType = idm_report_export_service_client_js_1.ReportElementViewType;
        this.COLUMN_MIN_WIDTH = 120;
        /**
         * Maximum number of rows,which can be rendered in view .
         * @type {number}
         */
        this.totalRenderingRowsLimit = 200000;
        /**
         * Height of report table view.
         * @type {number}
         */
        this.viewHeight = 400;
        /**
         * Warning message will be shown, if rendering row count is above given threshold.
         * @type {number}
         */
        this.warningMessageThreshold = 10000;
        /**
         * Drill down filters
         */
        this.filters = [];
        this.exactCount = true;
        this.initialized = false;
        this.isProgressSpinnerEnabled = false;
        /**
         * Show disaggregation check box should be visible in case indicator
         * exists at least in one row branch as last element
         */
        this.hasIndicatorInRowBranchAsLastElement = false;
        this.references = [];
        this.showDisaggregation = false;
        this.validationResultMessages = [];
        this.reportingError = false;
        this.isReportValidSubject = new BehaviorSubject_1.BehaviorSubject(true);
        this.exportPageOrientation = idm_report_export_service_client_js_1.ExportPageOrientation.PORTRAIT;
        this.csvDelimiter = idm_report_export_service_client_js_2.CSVDelimiter.COMMA;
        /**
         * Messages kev value pairs, which are loading in constructor
         */
        this.messages = new Map();
        this.openSubscriptions = [];
        this._currencies = new Map();
        this.pageFilterTreeDto = null;
        this.defaultIconURL = null;
        this.categoryIconIdURLMap = new Map();
        this.isCardTitleLongerThenToolbarSection = false;
        this.subscribedToPageFilterChange = false;
        this.tableHead = [];
        this.tableVisibleData = [];
        this.tableAllData = [];
        this.colGroups = [];
        this.rowCategoryLevelsCount = 1;
        this.isLanguagesLoaded = false;
        this.loadCategoryIconPath();
        this.initMessages();
        this.destroy$ = new Subject_1.Subject();
    }
    SisTabularReportViewComponent_1 = SisTabularReportViewComponent;
    Object.defineProperty(SisTabularReportViewComponent.prototype, "title", {
        /**
         * Setter for report title which deserializes from string before setting multilingual value
         * @param title
         */
        set: function (title) {
            this.reportTitle = idm_reporting_controls_1.MultilingualTypeHelper.deserializeMultilingualString(title);
        },
        enumerable: true,
        configurable: true
    });
    SisTabularReportViewComponent.prototype.ngOnChanges = function (changes) {
        if (changes && (changes['state'] || changes['filters'])) {
            this.clearState();
            this.redrawWithSubscribeToPageFilterChange();
        }
    };
    SisTabularReportViewComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        if (this.rcTableToolbarSection && this.rcTableToolbarTitle) {
            var toolbarTitleMarginRight = 16;
            this.isCardTitleLongerThenToolbarSection = this.rcTableToolbarSection.nativeElement.offsetWidth === this.rcTableToolbarTitle.nativeElement.offsetWidth +
                toolbarTitleMarginRight;
        }
        this._cd.detectChanges();
    };
    SisTabularReportViewComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
        this.openSubscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
        if (this._processReportSubscription) {
            this._processReportSubscription.unsubscribe();
        }
        this._processReportSubscription = null;
    };
    SisTabularReportViewComponent.prototype.onExpand = function (event) {
        var detail = event.detail;
        var clickedItemIndex = Number(detail.identifier);
        if (detail.identifier && !isNaN(clickedItemIndex)) {
            this.tableAllData[clickedItemIndex].collapsed = false;
        }
    };
    SisTabularReportViewComponent.prototype.onCollapse = function (event) {
        var detail = event.detail;
        var clickedItemIndex = Number(detail.identifier);
        if (detail.identifier && !isNaN(clickedItemIndex)) {
            this.tableAllData[clickedItemIndex].collapsed = true;
        }
    };
    SisTabularReportViewComponent.prototype.showLoadMore = function () {
        return this.tableAllData.length > this.tableVisibleData.length
            && this.tableVisibleData.length < SisTabularReportViewComponent_1.LOAD_ALL_PAGING_SIZE;
    };
    /**
     * Set visible the next {@link SisTabularReportViewComponent.PAGING_SIZE} items in view.
     */
    SisTabularReportViewComponent.prototype.onLoadMore = function () {
        var _this = this;
        var incrementSize = this.tableVisibleData.length + SisTabularReportViewComponent_1.PAGING_SIZE > SisTabularReportViewComponent_1.LOAD_ALL_PAGING_SIZE
            ? SisTabularReportViewComponent_1.LOAD_ALL_PAGING_SIZE - this.tableVisibleData.length
            : SisTabularReportViewComponent_1.PAGING_SIZE;
        var currentVisibleDataSize = this.tableVisibleData.length + incrementSize;
        if (currentVisibleDataSize > this.warningMessageThreshold) {
            this.actualCountOfRows = currentVisibleDataSize;
            var dialogRef = this.dialog.open(sis_tabular_report_view_big_data_warning_popup_component_1.ReportViewBigDataWarningPopupComponent, {
                width: '420px',
                data: {
                    actualNumber: this.actualCountOfRows.toString(),
                    maxAvailableCount: this.warningMessageThreshold.toString()
                }
            });
            this.openSubscriptions.push(dialogRef.afterClosed().subscribe(function (approved) {
                if (approved) {
                    _this.tableVisibleData = _this.tableAllData.slice(0, currentVisibleDataSize);
                }
                else {
                    currentVisibleDataSize -= incrementSize;
                    _this.actualCountOfRows = currentVisibleDataSize;
                }
            }));
        }
        else {
            this.tableVisibleData = this.tableAllData.slice(0, currentVisibleDataSize);
        }
    };
    SisTabularReportViewComponent.prototype.clearState = function () {
        this.tableVisibleData = [];
        this.tableAllData = [];
        this.tableHead = [];
        this.validationResultMessages = [];
        this.hasIndicatorInRowBranchAsLastElement = false;
        this.rowCategoryLevelsCount = 1;
    };
    SisTabularReportViewComponent.prototype.resetState = function () {
        var _this = this;
        this.extractReportJson();
        this.datasetSelected = this.dataSetId !== null;
        if (this.datasetSelected) {
            if (!this.isLanguagesLoaded) {
                this._currentLanguageProvider.getCurrentLanguage()
                    .pipe(operators_1.takeUntil(this.destroy$), operators_1.switchMap(function (language) {
                    _this.currentLanguageId = language.getId();
                    return zip_1.zip(from_1.from(_this.localeService.getLocaleInfo(_this.currentLanguageId)), from_1.from(_this._messageService.getMessages(_this.currentLanguageId, Array.from(_this.messages.keys()))));
                }))
                    .subscribe(function (data) {
                    _this.localeInfo = data[0];
                    _this.messages = data[1];
                    _this.isLanguagesLoaded = true;
                    _this.clearState();
                    if (_this.validateReportStructure()) {
                        _this.processNewDatasetAndReport();
                    }
                    _this.obtainReferences();
                });
            }
            else {
                this.clearState();
                if (this.validateReportStructure()) {
                    this.processNewDatasetAndReport();
                }
            }
        }
    };
    SisTabularReportViewComponent.prototype.isDatasetSelected = function () {
        return this.datasetSelected;
    };
    SisTabularReportViewComponent.prototype.isReportConfigured = function () {
        var _this = this;
        var notEmptyReport = function () { return Boolean(_this.reportDto &&
            (_this.reportDto.rowRootDto.children.length || _this.reportDto.columnRootDto.children.length || _this.reportDto.tableGrouping.elements.length)); };
        return this.isDatasetSelected() && notEmptyReport();
    };
    SisTabularReportViewComponent.prototype.onShowDisaggregationChange = function (checked) {
        this.reportOptions.showIndicatorDisaggregations = checked;
        this.showDisaggregation = checked;
        this.processNewDatasetAndReport();
    };
    SisTabularReportViewComponent.prototype.addExportPageOrientation = function (pageOrientation) {
        this.exportPageOrientation = pageOrientation;
    };
    SisTabularReportViewComponent.prototype.addCsvDelimiter = function (csvDelimiter) {
        this.csvDelimiter = csvDelimiter;
    };
    SisTabularReportViewComponent.prototype.buildExportReport = function (exportType) {
        var _a = this.getExportData(this.exportPageOrientation, this.csvDelimiter), exportReport = _a.exportReport, exportReportFilter = _a.exportReportFilter, reportOptions = _a.reportOptions;
        this.showProgressSpinner();
        this._reportExportService.exportReport(exportReport, exportType, exportReportFilter, this.currentLanguageId, reportOptions, null, this.dataSetId);
        this.hideProgressSpinner();
    };
    SisTabularReportViewComponent.prototype.obtainReferences = function () {
        var _this = this;
        this.references = [];
        var references = [];
        var referenceNumbers = new Set();
        if (this.reportViewStyles.rowBranchStylesDto) {
            this.reportViewStyles.rowBranchStylesDto.forEach(function (rbs) {
                return rbs.categoriesStyle.forEach(function (rcs) {
                    if (rcs.reference && !referenceNumbers.has(rcs.reference.referenceNumber.text.getValue(_this.currentLanguageId))) {
                        references.push(rcs.reference);
                        referenceNumbers.add(rcs.reference.referenceNumber.text.getValue(_this.currentLanguageId));
                    }
                });
            });
        }
        if (this.reportViewStyles.columnBranchStylesDto) {
            this.reportViewStyles.columnBranchStylesDto.forEach(function (cbs) {
                cbs.categoriesStyle.forEach(function (rcs) {
                    return rcs.reference && references.push(rcs.reference);
                });
                if (cbs.measureStyle && cbs.measureStyle.reference) {
                    references.push(cbs.measureStyle.reference);
                }
            });
        }
        references.sort(function (ref1, ref2) {
            return ((+ref1.referenceNumber.text.getValue(_this.currentLanguageId)) - (+ref2.referenceNumber.text.getValue(_this.currentLanguageId)));
        });
        references.forEach(function (ref) {
            var reference = ref.referenceNumber.text.getValue(_this.currentLanguageId) + ' : ' + ref.referenceText.text.getValue(_this.currentLanguageId);
            _this.references.push(reference);
        });
    };
    /**
     * Constructs and return export data
     * @param exportPageOrientation
     * @private
     */
    SisTabularReportViewComponent.prototype.getExportData = function (exportPageOrientation, csvDelimiter) {
        if (csvDelimiter === void 0) { csvDelimiter = idm_report_export_service_client_js_2.CSVDelimiter.COMMA; }
        var exportReport = export_report_dto_converter_1.ExportReportDtoConverter.convertToExportReportDto(this.reportDto);
        exportReport.exportReportStylesDto = new idm_report_export_service_client_js_1.ExportReportStylesDto();
        exportReport.exportReportStylesDto.exportPageOrientation = exportPageOrientation;
        exportReport.exportReportStylesDto.csvDelimiter = csvDelimiter;
        if (this.reportViewStyles.rowBranchStylesDto) {
            exportReport.exportReportStylesDto.rowBranchStylesDto = this.reportViewStyles.rowBranchStylesDto;
        }
        if (this.reportViewStyles.columnBranchStylesDto) {
            exportReport.exportReportStylesDto.columnBranchStylesDto = this.reportViewStyles.columnBranchStylesDto;
        }
        exportReport.exportReportStylesDto.title = new idm_report_export_service_client_js_1.MultilingualStyledTextDto(this.reportTitle, null);
        var exportReportFilter = this.filterTreeDto;
        Object.assign(exportReport.exportReportStylesDto, this.state.exportReportStyles);
        exportReport.exportReportStylesDto.header = report_view_styles_deserializer_1.ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(exportReport.exportReportStylesDto.header);
        exportReport.exportReportStylesDto.footer = report_view_styles_deserializer_1.ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(exportReport.exportReportStylesDto.footer);
        var reportOptions = this.reportOptions;
        return {
            exportReport: exportReport,
            exportReportFilter: exportReportFilter,
            reportOptions: reportOptions
        };
    };
    SisTabularReportViewComponent.prototype.validateReportStructure = function () {
        this.reportConfigured = this.isReportConfigured();
        if (!this.reportConfigured) {
            this.validationResultMessages.push(this.messages.get(SisTabularReportViewComponent_1.CONFIGURATION_NOT_COMPLETE));
        }
        this.isReportValidSubject.next(this.reportConfigured);
        return this.reportConfigured;
    };
    /**
     * If there was a change in filter, language, data set id, reporting options then redraw reporting
     */
    SisTabularReportViewComponent.prototype.processNewDatasetAndReport = function () {
        var _this = this;
        var categoryAndMeasurePathsObservable = from_1.from(this._pathService.getPaths(this.dataSetId));
        var categoryExpressionPathsObservable = from_1.from(this._expressionPathService.getCategoryExpressionPaths(this.dataSetId));
        var rootPathObservable = from_1.from(this._categoryPathService.getRootCategoryPath(this.dataSetId));
        var metaCategories = this.kbService.getAllMetaCategories('reporting');
        var currencies$ = skynet_store_currencies_api_1.currencyStoreManager.selectAll(this.store)
            .pipe(operators_1.filter(function (currencies) { return !currencies.isEmpty(); }));
        var pathHolderForms$ = this._pathFormsService.getPathHolderForms(this.dataSetId);
        if (this._processReportSubscription) {
            this._processReportSubscription.unsubscribe();
        }
        this._processReportSubscription = combineLatest_1.combineLatest(categoryAndMeasurePathsObservable, categoryExpressionPathsObservable, rootPathObservable, metaCategories, currencies$, pathHolderForms$)
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.switchMap(function (data) {
            _this.categoryAndMeasurePaths = data[0];
            _this.categoryExpressionPaths = data[1];
            var map = new Map();
            if (data[3]) {
                data[3].forEach(function (metaCategory) {
                    map.set(metaCategory.getSystemName(), metaCategory);
                });
            }
            _this.metaCategories = map;
            // load category icons
            var categories = [];
            categories = categories.concat(_this.collectCategoryNames(_this.reportDto.rowRootDto.children), _this.collectCategoryNames(_this.reportDto.columnRootDto.children));
            var categoryIconsPromise = categories.length !== 0 ? _this.getCategoryIconMap(categories) : Promise.resolve(new Map());
            if (data[4]) {
                Array.from(data[4].toList()).forEach(function (currency) {
                    _this._currencies.set(currency.id, currency);
                });
            }
            _this.pathHolderForms = data[5] || [];
            return zip_1.zip(of_1.of(data[2]), from_1.from(categoryIconsPromise));
        }))
            .subscribe(function (data) {
            _this.categoryIconIdURLMap = data[1];
            _this.widgetTitle = _this.getWidgetTitle();
            _this.updateFilters(data[0]).then(function () {
                _this.processReportStructure(_this.currentLanguageId);
            });
        });
    };
    /**
     * Receives report JSON data, converts it to suitable structure for table rendering
     */
    SisTabularReportViewComponent.prototype.processReportStructure = function (currentLanguageId) {
        var _this = this;
        this.showProgressSpinner();
        var reportDataLoadPromise = this.getReportJson(this.reportDto, this.filterTreeDto, this.dataSetId, currentLanguageId, this.reportOptions, idm_reporting_service_client_js_1.PagingCriteria.of(0, SisTabularReportViewComponent_1.LOAD_ALL_PAGING_SIZE));
        this.reportingError = false;
        reportDataLoadPromise.then(function (reportData) {
            if (reportData.tables.length) {
                var measureTypes_1 = _this.processMeasureObjects(tree_utils_1.TreeUtils.getMeasurePathTypesByBranchIndex(_this.reportDto.columnRootDto, _this.categoryAndMeasurePaths, _this.categoryExpressionPaths));
                _this.converter = new report_json_converter_1.ReportJsonConverter(_this.messages, _this.reportViewStyles, _this.categoryAndMeasurePaths, _this.dataSetId, _this.reportDto, _this.localeService, _this._formResolverService, _this.pathHolderForms, _this.localeInfo, measureTypes_1, _this.metaCategories, _this.defaultIconURL, _this.categoryIconIdURLMap);
                var reportDataTable_1 = reportData.tables[0];
                _this.rowCategoryLevelsCount = reportDataTable_1.rowGrouping[0].rowCategories.length;
                var rowGroupingTitle = _this.rowCategoryLevelsCount !== 0 ? _this.getRowGroupingCaption(_this.reportDto, currentLanguageId)
                    : null;
                _this.tableHead = _this.converter.createTableHead(reportDataTable_1.columnGrouping.values, _this.reportDto.columnRootDto, _this.categoryAndMeasurePaths, currentLanguageId, rowGroupingTitle);
                _this.colGroups = _this.converter.getColGroups(reportDataTable_1.columnIndexes);
                _this.removeUnspecifiedBranches(reportDataTable_1);
                // if there is report data after removing unspecified branches
                if (reportDataTable_1.rowGrouping.length) {
                    _this.setColumnTreeToRowFormattingRules(_this.reportViewStyles, _this.reportDto.columnRootDto, reportDataTable_1.columnIndexes);
                    _this.localeService.getLocaleInfo(_this.currentLanguageId).then(function (localeInfo) {
                        _this.tableAllData = _this.converter.getTableData(reportDataTable_1.rowGrouping, reportDataTable_1.columnIndexes, measureTypes_1, _this.currentLanguageId, localeInfo);
                        _this.totalRowsCount = Math.min(SisTabularReportViewComponent_1.LOAD_ALL_PAGING_SIZE, _this.tableAllData.length);
                        _this.exactCount = _this.tableAllData.length <= SisTabularReportViewComponent_1.LOAD_ALL_PAGING_SIZE;
                        if (reportDataTable_1.rowGrouping[0].rowCategories.length > 1) {
                            var index = 0;
                            while (index < _this.tableAllData.length) {
                                index = _this.setChildrenCount(index);
                            }
                        }
                        if (_this.tableAllData.length > _this.totalRenderingRowsLimit) {
                            _this.validationResultMessages = _this.validationResultMessages.concat(_this.obtainReportingServiceErrorMessages());
                            _this.isReportValidSubject.next(false);
                        }
                        else {
                            _this.hasIndicatorInBranchesAsLastItem();
                            _this.tableVisibleData = _this.tableAllData.slice(0, SisTabularReportViewComponent_1.INITIAL_VISIBLE_DATA_SIZE);
                            if (_this.communicationService) {
                                _this.sendWidgetExportData();
                            }
                        }
                    });
                }
                else {
                    _this.validationResultMessages.push(_this.messages.get(SisTabularReportViewComponent_1.MESSAGE_KEY_NO_DATA));
                    _this.isReportValidSubject.next(false);
                }
            }
            else {
                _this.validationResultMessages.push(_this.messages.get(SisTabularReportViewComponent_1.MESSAGE_KEY_NO_DATA));
                _this.isReportValidSubject.next(false);
            }
            _this.hideProgressSpinner();
        });
        reportDataLoadPromise.catch(function (reason) {
            if (reason.status === 422) {
                _this.validationResultMessages = _this.validationResultMessages.concat(_this.messages.get(SisTabularReportViewComponent_1.HUGE_REPORT_ABOVE_TWO_MILLIONS));
            }
            else if (reason.status === 413) {
                _this.validationResultMessages = _this.validationResultMessages.concat(_this.messages.get(SisTabularReportViewComponent_1.HUGE_REPORT_ABOVE_TEN_THOUSANDS));
            }
            else {
                _this.reportingError = true;
            }
            _this.isReportValidSubject.next(false);
            _this.hideProgressSpinner();
        });
    };
    SisTabularReportViewComponent.prototype.processMeasureObjects = function (measureTypeMap) {
        var measureTypes = new Map();
        var branchIndexMeasures = tree_utils_1.TreeUtils.getMeasureByBranchIndex(this.reportDto.columnRootDto);
        for (var _i = 0, _a = Array.from(measureTypeMap.keys()); _i < _a.length; _i++) {
            var key = _a[_i];
            var measureTypeObject = {};
            var el = branchIndexMeasures.get(key);
            if (el instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                if (el.currencyId !== null && el.currencyId !== undefined) {
                    measureTypeObject.symbol = this._currencies.get(el.currencyId).symbol;
                }
            }
            else if (el instanceof idm_reporting_service_client_js_1.ColumnCategoryDto && el.categoryElementDto.showAsType === idm_reporting_service_client_js_1.ShowAsType.LIST_OF_NAME_IDS) {
                measureTypeObject.categoryPathHolderId = el.categoryElementDto.categoryPathHolderId;
            }
            measureTypeObject.measureType = measureTypeMap.get(key);
            measureTypes.set(key, measureTypeObject);
        }
        return measureTypes;
    };
    SisTabularReportViewComponent.prototype.hasIndicatorInBranchesAsLastItem = function () {
        var _this = this;
        this.converter.getRowBranches().forEach(function (rowCategoryDtos) {
            if (rowCategoryDtos.length > 0) {
                var pathHolderId = rowCategoryDtos[rowCategoryDtos.length - 1].categoryElementDto.categoryPathHolderId;
                if (_this.categoryAndMeasurePaths.categoryPaths.get(pathHolderId).metaCategoryId.systemName === 'Indicator') {
                    _this.hasIndicatorInRowBranchAsLastElement = true;
                }
            }
        });
    };
    /**
     *
     * @param index
     * @private
     */
    SisTabularReportViewComponent.prototype.setChildrenCount = function (index) {
        var row = this.tableAllData[index];
        index++;
        var nextRow = this.tableAllData[index];
        row.childrenCount = 0;
        while (nextRow && row.level + 1 === nextRow.level) {
            row.childrenCount++;
            index = this.setChildrenCount(index);
            nextRow = this.tableAllData[index];
        }
        return index;
    };
    SisTabularReportViewComponent.prototype.isUnspecified = function (rowCategory) {
        return rowCategory.id === null && !rowCategory.isTotal;
    };
    SisTabularReportViewComponent.prototype.removeUnspecifiedsFromTail = function (rowCategories) {
        while (rowCategories[rowCategories.length - 1] && this.isUnspecified(rowCategories[rowCategories.length - 1])) {
            // removes the whole branch which has unspecified as last category
            rowCategories = [];
        }
        return rowCategories;
    };
    SisTabularReportViewComponent.prototype.setColumnTreeToRowFormattingRules = function (reportViewStyles, columnRootDto, columnBranchIndexes) {
        row_formatting_rules_column_tree_setter_1.RowFormattingRulesColumnTreeSetter.setColumnTreeToRowFormattingRules(reportViewStyles, columnRootDto, columnBranchIndexes);
    };
    SisTabularReportViewComponent.prototype.showProgressSpinner = function () {
        this.isProgressSpinnerEnabled = true;
    };
    SisTabularReportViewComponent.prototype.hideProgressSpinner = function () {
        var _this = this;
        setTimeout(function () {
            _this.isProgressSpinnerEnabled = false;
        }, 500);
    };
    /**
     * Execute report with given parameters
     * @returns {Promise<string>}
     */
    SisTabularReportViewComponent.prototype.getReportJson = function (reportDto, filterTreeDto, dataSetId, languageId, reportOptions, pagingCriteria) {
        reportOptions.fetchBranchIndexes = true;
        reportOptions.fetchColumnIndexes = true;
        reportOptions.fetchLevelIndexes = true;
        return this._reportingService.executeReport(reportDto, filterTreeDto, languageId, dataSetId, reportOptions, pagingCriteria);
    };
    /**
     * Creating first columns name if it is possible (see canAppendName(rowCategoryDto: RowCategoryDto) doc)
     * @param reportDto
     * @param languageId
     * @returns {string}
     */
    SisTabularReportViewComponent.prototype.getRowGroupingCaption = function (reportDto, languageId) {
        var name = ' ';
        if (this.canDisplayRowGroupingCaption(reportDto.rowRootDto)) {
            var rowRowElement = reportDto.rowRootDto;
            var names = [];
            var pathIds = [];
            while (rowRowElement.children.length !== 0) {
                names.push(this.getCategoryElementName(rowRowElement.children[0].categoryElementDto, this.categoryAndMeasurePaths.categoryPaths, languageId));
                pathIds.push(rowRowElement.children[0].categoryElementDto.categoryPathHolderId);
                rowRowElement = rowRowElement.children[0];
            }
            var cellValueFormatter = new cell_value_formatter_1.CellValueFormatter(this.reportViewStyles);
            name = cellValueFormatter.formatRowGroupingCaption(names, pathIds, languageId);
        }
        return name;
    };
    /**
     * Get category element name from paths map
     * We only have category path ids in categoryElementDto
     *
     * @param categoryElementDto category element
     * @param paths map where keys are path ids, values are corresponding path objects
     * @param languageId language's id
     * @returns {string}
     */
    SisTabularReportViewComponent.prototype.getCategoryElementName = function (categoryElementDto, paths, languageId) {
        return paths.get(categoryElementDto.categoryPathHolderId).name.get(languageId);
    };
    SisTabularReportViewComponent.prototype.canDisplayRowGroupingCaption = function (rowRootDto) {
        return rowRootDto.children.length === 1 ? this.canAppendName(rowRootDto.children[0]) : false;
    };
    /**
     * Checking whether we can get first columns name by using report model.
     * For example if we put in rows:
     * Category1
     *      Category2
     *          Category3
     *
     * column's name will be Category1/Category2/Category3
     *
     * But if we put reports like
     * Category1
     *      Category2
     *      Category3
     *
     * or like
     *
     * Category1
     *      Category2
     * Category3
     *      Category4
     *
     * we cannot get name
     *
     * @param rowCategoryDto row categories
     * @returns {boolean}
     */
    SisTabularReportViewComponent.prototype.canAppendName = function (rowCategoryDto) {
        var canAppend;
        if (rowCategoryDto.children.length === 0) {
            canAppend = true;
        }
        else {
            if (rowCategoryDto.children.length === 1) {
                var childDto = rowCategoryDto.children[0];
                canAppend = this.canAppendName(childDto);
            }
            else {
                canAppend = false;
            }
        }
        return canAppend;
    };
    SisTabularReportViewComponent.prototype.initMessages = function () {
        this.messages.set('reporting.UNSPECIFIED', '');
        this.messages.set(SisTabularReportViewComponent_1.MESSAGE_KEY_NO_DATA, '');
        this.messages.set(SisTabularReportViewComponent_1.PAGING_STATE, '');
        this.messages.set(SisTabularReportViewComponent_1.CONFIGURATION_NOT_COMPLETE, '');
        this.messages.set(SisTabularReportViewComponent_1.TABLE_LOADING_ERROR_MESSAGE, '');
        this.messages.set(SisTabularReportViewComponent_1.REPORT_SERVICE_ERROR_MESSAGE, '');
        this.messages.set(SisTabularReportViewComponent_1.HUGE_REPORT_ABOVE_TEN_THOUSANDS, '');
        this.messages.set(SisTabularReportViewComponent_1.HUGE_REPORT_ABOVE_TWO_MILLIONS, '');
        this.messages.set(SisTabularReportViewComponent_1.BOOLEAN_MEASURE_VALUE_TRUE, '');
        this.messages.set(SisTabularReportViewComponent_1.BOOLEAN_MEASURE_VALUE_FALSE, '');
        this.messages.set(SisTabularReportViewComponent_1.UNTITLED_MESSAGE_KEY, '');
    };
    /**
     * Adds filters after page change.
     * Filters' structure is [{"systemName": "Project", "items": [1,2,3]}]
     * In case filter contains root category's systemName it is filtered ONLY by root category, else OR filter is used.
     * @param root: CategoryPathDto Root category of current dataset
     * */
    SisTabularReportViewComponent.prototype.updateFilters = function (root) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (typeof _this.filters === 'string') {
                _this.filters = JSON.parse(_this.filters);
            }
            if (Array.isArray(_this.filters) && _this.filters.length > 0) {
                var systemNamePathIds_1 = _this.createCategorySystemNamePathIdsMap();
                _this.filters.forEach(function (filterItem) {
                    var filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createOrFilterBuilder();
                    var pathIds = systemNamePathIds_1.get(filterItem.systemName);
                    if (pathIds.includes(root.id)) {
                        filterBuilder.filterByCategory(root.id).in(filterItem.items);
                    }
                    else {
                        pathIds.forEach(function (id) {
                            filterBuilder.filterByCategory(id).in(filterItem.items);
                        });
                    }
                    _this.filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.and(_this.filterTreeDto, filterBuilder.build());
                });
            }
            if (_this.filters && !Array.isArray(_this.filters) && typeof _this.filters === 'object') {
                _this.filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(_this.filterTreeDto, _this.filters);
            }
            if (_this.pageFilterTreeDto) {
                _this.filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(_this.filterTreeDto, _this.pageFilterTreeDto);
            }
            resolve(true);
        });
    };
    SisTabularReportViewComponent.prototype.createCategorySystemNamePathIdsMap = function () {
        var systemNamePathIds = new Map();
        this.categoryAndMeasurePaths.categoryPaths.forEach(function (categoryPath) {
            if (systemNamePathIds.has(categoryPath.metaCategoryId.systemName)) {
                var pathIds = systemNamePathIds.get(categoryPath.metaCategoryId.systemName);
                pathIds.push(categoryPath.id);
            }
            else {
                systemNamePathIds.set(categoryPath.metaCategoryId.systemName, [categoryPath.id]);
            }
        });
        return systemNamePathIds;
    };
    /**
     * Extracts fields from report json
     */
    SisTabularReportViewComponent.prototype.extractReportJson = function () {
        if (this.state) {
            var jsonObject = typeof this.state === 'string' ? JSON.parse(this.state) : this.state;
            this.reportDto = jsonObject.report ? report_deserializer_1.ReportDeserializer.fromJson(jsonObject.report) : new idm_reporting_service_client_js_1.ReportDtoBuilder().build();
            this.reportViewStyles = jsonObject.reportViewStyles ? report_view_styles_deserializer_1.ReportViewStylesDeserializer.fromJson(jsonObject.reportViewStyles)
                : report_view_styles_1.ReportViewStyles.createReportViewStyles();
            this.filterTreeDto = jsonObject.filters ? idm_reporting_service_client_js_1.FilterTreeDto.fromJson(JSON.stringify(jsonObject.filters)) : idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder().build();
            this.reportOptions = jsonObject.reportOptions ? idm_reporting_service_client_js_1.ReportOptions.fromJson(JSON.stringify(jsonObject.reportOptions)) : new idm_reporting_service_client_js_1.ReportOptions();
            this.showDisaggregation = this.reportOptions.showIndicatorDisaggregations;
            this.reportOptions.fetchBranchIndexes = true;
            this.reportOptions.fetchColumnIndexes = true;
            this.reportOptions.fetchLevelIndexes = true;
        }
        else {
            this.reportDto = new idm_reporting_service_client_js_1.ReportDtoBuilder().build();
            this.filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder().build();
            this.reportViewStyles = report_view_styles_1.ReportViewStyles.createReportViewStyles();
            this.reportOptions = new idm_reporting_service_client_js_1.ReportOptions();
            this.showDisaggregation = false;
        }
    };
    SisTabularReportViewComponent.prototype.obtainReportingServiceErrorMessages = function () {
        var message = this.messages.get(SisTabularReportViewComponent_1.REPORT_SERVICE_ERROR_MESSAGE)
            .replace('{0}', this.totalRenderingRowsLimit.toString());
        return [this.messages.get(SisTabularReportViewComponent_1.TABLE_LOADING_ERROR_MESSAGE), message];
    };
    SisTabularReportViewComponent.prototype.redrawWithSubscribeToPageFilterChange = function () {
        var _this = this;
        if (this._activatedRoute && this.pageFilterService && !this.subscribedToPageFilterChange) {
            this.openSubscriptions.push(this._activatedRoute.params
                .pipe(operators_1.take(1), operators_1.switchMap(function (params) {
                _this.pageId = params['pageId'];
                _this.pageFilterService.requestPageFilter();
                return _this.pageFilterService.getFilterChange();
            }))
                .subscribe(function (filtersMap) {
                if (_this.pageId && filtersMap && filtersMap.has(_this.pageId)) {
                    if (_this.dataSetId) {
                        var filterItem = filtersMap.get(_this.pageId).get(_this.dataSetId) || null;
                        if (_this.pageFilterTreeDto !== filterItem) {
                            _this.pageFilterTreeDto = filterItem;
                        }
                    }
                    _this.clearState();
                    _this.resetState();
                }
                else if (!_this.subscribedToPageFilterChange) {
                    _this.resetState();
                }
                else if ((!filtersMap || !filtersMap.has(_this.pageId)) && _this.pageFilterTreeDto) {
                    _this.pageFilterTreeDto = null;
                    _this.resetState();
                }
                _this.subscribedToPageFilterChange = true;
            }));
        }
        else {
            this.resetState();
        }
    };
    SisTabularReportViewComponent.prototype.loadCategoryIconPath = function () {
        var _this = this;
        this.staticResourceUrlProvider.getStaticResourcesUrl()
            .then(function (path) {
            _this.defaultIconURL = "" + path.url + SisTabularReportViewComponent_1.CATEGORIES_ICONS_PATH + "default";
        })
            .catch(function (error) {
            console.warn('Category icon path is missing ! Please define category icon path.', error);
        });
    };
    SisTabularReportViewComponent.prototype.getCategoryIconMap = function (categories) {
        var _this = this;
        var categoryIconPromises = categories.map(function (category) { return _this.staticResourceUrlProvider.getResources("" + SisTabularReportViewComponent_1.CATEGORIES_ICONS_PATH + category); });
        return Promise.all(categoryIconPromises)
            .then(function (resourceList) {
            var resourceIdURLMap = new Map();
            resourceList.forEach(function (resources) {
                resources.forEach(function (resource) {
                    var id = resource.split("" + SisTabularReportViewComponent_1.CATEGORIES_ICONS_PATH)[1];
                    resourceIdURLMap.set(id, resource);
                });
            });
            return resourceIdURLMap;
        });
    };
    SisTabularReportViewComponent.prototype.getExportDto = function (type, orientation) {
        var exportType = idm_report_export_service_client_js_1.ExportType[idm_dynamic_controls_metadata_1.ExportType[type]];
        var exportOrientation = idm_report_export_service_client_js_1.ExportPageOrientation[idm_dynamic_controls_metadata_1.ExportOrientation[orientation]];
        var _a = this.getExportData(exportOrientation), exportReport = _a.exportReport, exportReportFilter = _a.exportReportFilter, reportOptions = _a.reportOptions;
        var params = new Map()
            .set('report', JSON.stringify(exportReport.reportDto))
            .set('exportReportStyle', JSON.stringify(exportReport.exportReportStylesDto.toJsonObject()))
            .set('filters', exportReportFilter.toJson())
            .set('languageId', this.currentLanguageId.toString())
            .set('reportOptions', reportOptions.toJson())
            .set('renderType', idm_report_export_service_client_js_1.ExportType[exportType])
            .set('dataSetId', this.dataSetId.toString())
            .set('pagingCriteria', idm_reporting_service_client_js_1.PagingCriteria.all().toJson());
        return {
            url: null,
            serviceKey: SisTabularReportViewComponent_1.REPORT_EXPORT_SERVICE_URL_KEY,
            serviceContext: SisTabularReportViewComponent_1.REPORT_EXPORT_SERVICE_ENDPOINT,
            method: SisTabularReportViewComponent_1.EXPORT_SERVICE_METHOD,
            cardTitle: this.widgetTitle,
            headers: new Map(),
            contentType: SisTabularReportViewComponent_1.REPORT_EXPORT_SERVICE_CONTENT_TYPE,
            body: null,
            params: params
        };
    };
    SisTabularReportViewComponent.prototype.getExportDtoForPublish = function (type, orientation) {
        var exportOrientation = idm_report_export_service_client_js_1.ExportPageOrientation[idm_dynamic_controls_metadata_1.ExportOrientation[orientation]];
        var _a = this.getExportData(exportOrientation), exportReport = _a.exportReport, exportReportFilter = _a.exportReportFilter, reportOptions = _a.reportOptions;
        var params = new Map()
            .set('report', exportReport.reportDto)
            .set('exportReportStyle', exportReport.exportReportStylesDto.toJsonObject())
            .set('filters', exportReportFilter)
            .set('languageId', this.currentLanguageId)
            .set('reportOptions', reportOptions)
            .set('dataSetId', this.dataSetId)
            .set('pagingCriteria', idm_reporting_service_client_js_1.PagingCriteria.all().toJson())
            .set('renderType', idm_report_export_service_client_js_1.ExportType[type]);
        return {
            url: null,
            serviceKey: SisTabularReportViewComponent_1.REPORT_EXPORT_SERVICE_URL_KEY,
            serviceContext: SisTabularReportViewComponent_1.REPORT_EXPORT_SERVICE_ENDPOINT,
            method: SisTabularReportViewComponent_1.EXPORT_SERVICE_METHOD,
            cardTitle: this.widgetTitle,
            headers: new Map(),
            contentType: SisTabularReportViewComponent_1.REPORT_EXPORT_SERVICE_CONTENT_TYPE,
            body: null,
            params: params
        };
    };
    SisTabularReportViewComponent.prototype.sendWidgetExportData = function () {
        var exportData = {
            id: this.id,
            title: this.widgetTitle,
            isOrientable: true,
            getExportDto: this.getExportDto.bind(this)
        };
        var message = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.WIDGET_EXPORT_DATA, exportData);
        this.communicationService.parentSubject.next(message);
    };
    SisTabularReportViewComponent.prototype.getWidgetTitle = function () {
        return (this.reportTitle && this.reportTitle.getValue(this.currentLanguageId))
            || this.messages.get(SisTabularReportViewComponent_1.UNTITLED_MESSAGE_KEY);
    };
    /**
     * Collects all category names which have icon
     * @param reportCategories
     * @private
     */
    SisTabularReportViewComponent.prototype.collectCategoryNames = function (reportCategories) {
        var _this = this;
        if (reportCategories.length === 0) {
            return [];
        }
        else {
            var categoriesWithIcons_1 = [];
            reportCategories.forEach(function (categoryDto) {
                if (categoryDto instanceof idm_reporting_service_client_js_1.RowCategoryDto || categoryDto instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                    var category = _this.metaCategories.get(_this.categoryAndMeasurePaths.categoryPaths.get(categoryDto.categoryElementDto.categoryPathHolderId).metaCategoryId.systemName);
                    if (category && category.getHasIcon()) {
                        categoriesWithIcons_1.push(category.getSystemName());
                    }
                }
                categoriesWithIcons_1 = categoriesWithIcons_1.concat(_this.collectCategoryNames(categoryDto.children));
            });
            return categoriesWithIcons_1;
        }
    };
    /**
     * Removes rows which contains only unspecified categories and removes unspecified rows from table
     * @param reportDataTable
     * @private
     */
    SisTabularReportViewComponent.prototype.removeUnspecifiedBranches = function (reportDataTable) {
        // if there were categories in row grouping and hide unspecified is on
        if (this.reportDto.rowRootDto.children.length > 0 && this.reportOptions.hideUnspecifiedRowHierarchy) {
            for (var _i = 0, _a = reportDataTable.rowGrouping; _i < _a.length; _i++) {
                var row = _a[_i];
                if (row.rowCategories[row.rowCategories.length - 1] && this.isUnspecified(row.rowCategories[row.rowCategories.length - 1])) {
                    row.values = new Array(row.values.length).fill(null);
                }
                row.rowCategories = this.removeUnspecifiedsFromTail(row.rowCategories);
            }
            reportDataTable.rowGrouping = reportDataTable.rowGrouping.filter(function (row) { return row.rowCategories.length !== 0; });
        }
    };
    var SisTabularReportViewComponent_1;
    SisTabularReportViewComponent.REPORT_EXPORT_SERVICE_CONTENT_TYPE = 'application/x-www-form-urlencoded';
    SisTabularReportViewComponent.REPORT_EXPORT_SERVICE_URL_KEY = 'report-export-service';
    SisTabularReportViewComponent.REPORT_EXPORT_SERVICE_ENDPOINT = '/export-report';
    SisTabularReportViewComponent.EXPORT_SERVICE_METHOD = 'POST';
    SisTabularReportViewComponent.MESSAGE_KEY_NO_DATA = 'reporting.controls.list-builder.placeholder.noData';
    SisTabularReportViewComponent.PAGING_STATE = 'reporting_designer_paging_state';
    SisTabularReportViewComponent.CONFIGURATION_NOT_COMPLETE = 'reporting_designer_report_configuration_not_complete';
    SisTabularReportViewComponent.TABLE_LOADING_ERROR_MESSAGE = 'reporting_designer_table_loading_error_message';
    SisTabularReportViewComponent.REPORT_SERVICE_ERROR_MESSAGE = 'reporting_designer_report_generating_error_message';
    SisTabularReportViewComponent.HUGE_REPORT_ABOVE_TWO_MILLIONS = 'reporting_designer_huge_report_above_two_millions';
    SisTabularReportViewComponent.HUGE_REPORT_ABOVE_TEN_THOUSANDS = 'reporting_designer_big_report_above_ten_thousands';
    SisTabularReportViewComponent.PAGING_SIZE = 100;
    SisTabularReportViewComponent.INITIAL_VISIBLE_DATA_SIZE = 10;
    SisTabularReportViewComponent.LOAD_ALL_PAGING_SIZE = 5000;
    SisTabularReportViewComponent.BOOLEAN_MEASURE_VALUE_TRUE = 'boolean_measure_value_true';
    SisTabularReportViewComponent.BOOLEAN_MEASURE_VALUE_FALSE = 'boolean_measure_value_false';
    SisTabularReportViewComponent.UNTITLED_MESSAGE_KEY = 'reporting_designer_untitled_table';
    SisTabularReportViewComponent.CATEGORIES_ICONS_PATH = 'categories/icons/';
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTabularReportViewComponent.prototype, "totalRenderingRowsLimit", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTabularReportViewComponent.prototype, "viewHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTabularReportViewComponent.prototype, "warningMessageThreshold", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTabularReportViewComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTabularReportViewComponent.prototype, "state", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTabularReportViewComponent.prototype, "filters", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTabularReportViewComponent.prototype, "dataSetId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisTabularReportViewComponent.prototype, "hasPublishingAccess", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisTabularReportViewComponent.prototype, "title", null);
    __decorate([
        core_1.ViewChild('rcTableToolbarSection'),
        __metadata("design:type", core_1.ElementRef)
    ], SisTabularReportViewComponent.prototype, "rcTableToolbarSection", void 0);
    __decorate([
        core_1.ViewChild('rcTableToolbarTitle'),
        __metadata("design:type", core_1.ElementRef)
    ], SisTabularReportViewComponent.prototype, "rcTableToolbarTitle", void 0);
    SisTabularReportViewComponent = SisTabularReportViewComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-view',
            template: require('./sis-tabular-report-view.component.html'),
            styles: [require('./sis-tabular-report-view.component.css')],
            encapsulation: core_1.ViewEncapsulation.None
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 12,
            groups: [
                {
                    identity: 'ReportingControls',
                    name: 'Reporting Controls',
                    nameMessageKey: 'reporting.controls.group.name',
                },
            ],
            settings: {
                main: sis_tabular_report_options_component_1.SisTabularReportOptionsComponent,
                central: sis_tabular_report_designer_component_1.SisTabularReportDesignerComponent
            },
            template: "<sis-tabular-report-view [id]=\"controlId\" [state]='%{state}' [dataSetId]='%{dataSetId}' [title]='%{title}' [hasPublishingAccess]=\"hasPublishingAccess\" [filters]=\"filters\"></sis-tabular-report-view>",
            iconInfo: 'list-alt',
            name: 'Table',
            nameKey: 'reporting_designer_widget_label',
            height: 400
        }),
        __param(19, core_1.Optional()),
        __param(20, core_1.Optional()),
        __metadata("design:paramtypes", [core_1.ElementRef,
            material_1.MatDialog,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_reporting_service_client_js_1.ReportingService,
            idm_dataset_service_client_js_1.PathService,
            idm_dataset_service_client_js_1.ExpressionPathService,
            idm_dataset_service_client_js_1.CategoryPathService,
            idm_authentication_client_js_1.HttpClientWrapper,
            idm_message_language_service_client_js_1.MessageService,
            idm_frontend_shared_1.FormResolverService,
            idm_dataset_service_client_js_1.PathFormsService,
            idm_report_export_service_client_js_1.ReportExportService,
            idm_session_data_provider_api_js_1.EventBase,
            core_1.ChangeDetectorRef,
            idm_locale_service_client_js_1.LocaleService,
            store_1.Store,
            idm_application_properties_service_client_js_1.StaticResourceUrlProvider,
            idm_kb_service_client_js_1.KbService,
            router_1.ActivatedRoute,
            idm_dynamic_controls_metadata_1.CommunicationService,
            idm_reporting_controls_1.PageFilterService])
    ], SisTabularReportViewComponent);
    return SisTabularReportViewComponent;
}());
exports.SisTabularReportViewComponent = SisTabularReportViewComponent;
//# sourceMappingURL=sis-tabular-report-view.component.js.map